<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Delete Screen
      </h2>
    </template>
    <template #modal-body>
      <div>
        <p>The screen you are trying to delete is associated with flows or scores.</p>
        <p>Choosing to delete the screen and then saving the form will remove any flow or score associated with it!</p>
        <p>Are you sure you want to delete the screen?</p>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--danger']"
          @click="handleDeleteScreen"
        >
          Delete Screen
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    screen: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {
    ...mapActions('forms', {
      removeDynamicFormScreen: 'removeDynamicFormScreen',
    }),
    handleDeleteScreen() {
      this.removeDynamicFormScreen(this.screen.number);
      this.isOpen = false;
    },
  },
};
</script>
<style lang="less" scoped>
.BorderedHeaderModal {
  .Notice {
    margin-bottom: 0;
  }
}
</style>
